import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsTargetedToLaunchPayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH;
    id: string;
    attributes: {
      aggregate: {
        projects_targeted_to_launch: InsightMetric;
      };
    };
  };
}

export const parseProjectsTargetedToLaunchPayload = (
  payload: BaseInsightPayload
): ProjectsTargetedToLaunchPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH,
    data.attributes,
    false,
    true,
    ['projects_targeted_to_launch']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { projects_targeted_to_launch: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_TARGETED_TO_LAUNCH,
      id: data.id,
      attributes: {
        aggregate: {
          projects_targeted_to_launch:
            typedAttributes.aggregate.projects_targeted_to_launch,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
